/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import createPromptV2Service from './createPromptV2Service';
import PROMPT_V2_SERVICE_TYPE from './promptV2ServiceConstants';

export const createGetPromptCatalogueService = (config) =>
  createPromptV2Service({ ...config, serviceType: PROMPT_V2_SERVICE_TYPE.CATALOGUE });

export const createGetPromptVersionService = (config) =>
  createPromptV2Service({ ...config, serviceType: PROMPT_V2_SERVICE_TYPE.VERSION });

export const createGetPromptVersionsService = (config) =>
  createPromptV2Service({ ...config, serviceType: PROMPT_V2_SERVICE_TYPE.VERSIONS });

export const createUpdatePromptService = (config) =>
  createPromptV2Service({ ...config, serviceType: PROMPT_V2_SERVICE_TYPE.UPDATE });

export const createGetPromptNameAvailabilityService = (config) =>
  createPromptV2Service({ ...config, serviceType: PROMPT_V2_SERVICE_TYPE.NAME_AVAILABILITY });

export const createGetPromptVersionGraphsService = (config) =>
  createPromptV2Service({ ...config, serviceType: PROMPT_V2_SERVICE_TYPE.VERSION_GRAPHS });
